import {Component, Input, OnInit} from '@angular/core';
import {ApprovalModel} from '../../shared/dto/approval.model';
import Swal, {default as swal} from 'sweetalert2';
import {ApprovalService} from '../../service/approval.service';
import {FormControl, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {ChecklistModel} from '../../shared/dto/checklist.model';
import {ChecklistService} from '../../service/checklist.service';
import {ChecklistEnum} from '../../shared/enums/checklist.enum';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';

@Component({
  selector: 'app-approve-checklist',
  templateUrl: './approve-checklist.component.html',
  styleUrls: ['./approve-checklist.component.scss']
})
export class ApproveChecklistComponent implements OnInit {

  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public checklist: ChecklistModel[];
  public isValidChecklist = true;
  public isValid = false;
  public selectedIdArr: number[]=[];
  public checklistId: number[]=[];
  public value: string;
  public type: string;
  public checklistType: string;

  constructor(private approvalService: ApprovalService, private router: Router, private checklistService: ChecklistService,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.type = this.approvalModel.type;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });

    this.getChecklist('approval');
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;
    this.approvalModel.selectedIdArr = this.selectedIdArr;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to approve the request?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.approveRequeat(this.approvalModel).subscribe(
          (success: string) => {
            this.isSucess = true;
            swal.fire('Success', 'Applicant Details Updated', 'success');
            this.router.navigate(['/dashboard/approval-pending', this.approvalModel.type]);
            this.approvalService.close();
          },
          (error) => {
            this.isError = true;
            swal.fire('Error', 'Error When Updating the Request', 'error');
          },
        );
      } else {
      }
    });
  }

  // getChecklist() {
  //   if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
  //     this.checklistType = ChecklistEnum.APPROVAL_EXM;
  //   }
  //
  //   if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
  //     this.checklistType = ChecklistEnum.APPROVAL_SHO;
  //   }
  //
  //   if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
  //     this.checklistType = ChecklistEnum.APPROVAL_DG;
  //   }
  //
  //   this.checklistService.getChecklistByType(this.checklistType).subscribe(
  //     (result: any ) => {
  //       this.checklist = result;
  //       if(this.checklist.length > 0) {
  //         this.checklist.forEach(item => {
  //           this.checklistId.push(item.id);
  //         });
  //         this.isValidChecklist = true;
  //       }else{
  //         this.isValidChecklist = false;
  //       }
  //     }
  //   );
  // }

  //get checklist by  approval and reject and return
  getChecklist(checkListType:String) {

    if(checkListType == 'approval'){
      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
        this.checklistType = ChecklistEnum.APPROVAL_EXM;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
        this.checklistType = ChecklistEnum.APPROVAL_SHO;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
        this.checklistType = ChecklistEnum.APPROVAL_DG;
      }
    }

    if(checkListType == 'reject'){
      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
        this.checklistType = ChecklistEnum.REJECT_EXM;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
        this.checklistType = ChecklistEnum.REJECT_SHO;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
        this.checklistType = ChecklistEnum.REJECT_DG;
      }
    }

    if(checkListType == 'return'){
      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
        this.checklistType = ChecklistEnum.RETURN_EXM;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) {
        this.checklistType = ChecklistEnum.RETURN_SHO;
      }

      if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
        this.checklistType = ChecklistEnum.RETURN_DG;
      }
    }

    this.checklistService.getChecklistByType(this.checklistType).subscribe(
      (result: any ) => {
        this.checklist = result;
        if(this.checklist.length > 0) {
          this.checklist.forEach(item => {
            this.checklistId.push(item.id);
          });
          this.isValidChecklist = true;
        }else{
          this.isValidChecklist = false;
        }
      }
    );
  }

  isAllSelected(id,event) {
    if(event.checked)
      this.selectedIdArr.push(id);
    else {
      var index = this.selectedIdArr.indexOf(id);
      if(index > -1)
        this.selectedIdArr.splice(index,1);
    }

    if(JSON.stringify(this.checklistId)==JSON.stringify(this.selectedIdArr)) {
      this.isValidChecklist = false;
    }else {
      this.isValidChecklist = true;
    }


  }


}
